import { useMutation } from '@tanstack/react-query';
import { client } from './client';

export interface CreateInviteDto {
  email: string;
  role: 'admin' | 'operator';
}

export interface CreateInviteResult {
  inviteToken: string;
  expiresIn: number;
}

export function useCreateInvite() {
  return useMutation({
    mutationFn: (data: CreateInviteDto) =>
      client.post<CreateInviteResult>('/invites', data).then((r) => r.data),
  });
}
